<template>
  <div>
    <div class="flex" v-if="style_t == 1">
      <div class="flex items-center ss-m-audio-box pr-20 rounded-full">
        <div
          class="rounded-full ss-m-audio-play-icon flex cursor-pointer"
          @click="togglePlay"
        >
          <span
            class="m-auto iconfont icon-play text-white text-20"
            v-if="isPaused"
          ></span>
          <span
            class="m-auto iconfont icon-pause text-white text-20"
            v-else
          ></span>
        </div>
        <div class="ss-m-audio-slider px-15">
          <a-slider :value="sliderPer" :tooltipVisible="false" />
        </div>
        <div class="text-24 text-gray-900">{{ durationString }}</div>
      </div>
    </div>

    <div class="flex" v-if="style_t == 2">
      <div class="flex items-center p-5 rounded-full bg-white shadow-lg">
        <div
          class="rounded-full w-50 h-50 flex cursor-pointer ss-style_t_2_box relative"
          @click="togglePlay"
        >
          <span
            class="m-auto iconfont icon-play text-white text-20 relative z-1"
            v-if="isPaused"
          ></span>
          <span
            class="m-auto iconfont icon-pause text-white text-20 relative z-1"
            v-else
          ></span>
          <!--          <div class="ss-back_td absolute left-0 top-0 rounded-full w-50 h-50 "></div>-->
        </div>
        <div class="px-10 ss-style_t_2_slider_box">
          <div
            class="text-13 font-bold text-gray-900 ss-ellipsis"
            :title="title"
          >
            当前：{{ title }}
          </div>
          <div class="ss-style_t_2_slider">
            <a-slider :value="sliderPer" :tooltipVisible="false" />
          </div>
          <div class="text-12 text-gray-501">时长：{{ durationString }}</div>
        </div>
      </div>
    </div>

    <audio ref="audio"></audio>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      // 音乐url
      type: String,
      default: "",
    },
    style_t: {
      // 音乐url
      type: Number,
      default: 1,
    },
    title: {
      // 标题
      type: String,
      default: "",
    },
  },
  data() {
    return {
      duration: 0, // 语音的总时间
      durationString: "", // 语音的时间
      currentTime: 0, // 语音当前播放的时间
      isPaused: true, // 是否是暂停或者停止
    };
  },
  methods: {
    _initAudio() {
      // 初始化语音
      if (this.audio) {
        this.audio.src = this.$props.src;
        this.audio.pause();
        this.isPaused = true;

        this.audio.addEventListener("canplaythrough", this.onCanplaythrough); // 事件在音频文件可以从头播放到尾时候触发。
        this.audio.addEventListener("timeupdate", this.onTimeupdate); // 每次currentTime属性值发生变化的时候会触发timeupdate事件。
        this.audio.play();
        this.audio.onplay = () => {
          this.isPaused = false;
          console.log("我开始播放了");
        };
        this.audio.onpause = () => {
          this.isPaused = true;
          console.log("我暂停了");
        };
        this.audio.onended = () => {
          this.isPaused = true;
          this.$emit('audioEnd')
          console.log("我播放结束了");
        };
      }
    },
    onCanplaythrough() {
      this.duration = this.audio.duration;
      this.durationString = this.format(this.audio.duration);
    },

    onTimeupdate() {
      // 语音一直播放的时候
      this.currentTime = this.audio.currentTime;
    },

    format(s) {
      var t = "";
      if (s > -1) {
        var min = Math.floor(s / 60) % 60;
        var sec = s % 60;
        if (min < 10) {
          t += "0";
        }
        t += min + "'";
        if (sec < 10) {
          t += "0";
        }
        t += sec.toFixed(2);
      }
      t = t.replace(".", '"');
      return t;
    },

    togglePlay() {
      // 是否是要播放
      if (this.audio.paused) {
        this.audio.play();
      } else {
        this.audio.pause();
      }
    },
  },
  created() {
      this.$nextTick(() => {
        this._initAudio() // 初始化数据
      })
    },
  computed:{
      audio() {
      return this.$refs.audio; // 语音实例
    },
    sliderPer(){
      return this.currentTime / this.duration * 100
    }
  }
};
</script>

<style scoped>
.ss-m-audio-slider {
  width: 320px;
}
.ss-m-audio-box {
  background: #fafafb;
}
.ss-m-audio-play-icon {
  width: 64px;
  height: 64px;
  background-image: linear-gradient(
    -38deg,
    rgb(13, 206, 191) 0%,
    rgb(9, 190, 176) 100%
  );
  box-shadow: 0px 5px 6px 0px rgba(13, 206, 191, 0.3);
}
>>> .ant-slider-track {
  background: #0dcebf;
}
>>> .ant-slider-handle {
  border-color: #0dcebf;
}
>>> .ant-slider-handle:focus {
  border-color: #0dcebf;
  box-shadow: 0 0 0 5px rgba(13, 206, 191, 0.2);
}
>>> .ant-slider:hover .ant-slider-handle:not(.ant-tooltip-open) {
  border-color: #0dcebf;
}
>>> .ant-slider:hover .ant-slider-track {
  background: #0dcebf;
}
.ss-style_t_2_box {
  background: #0dcebf;
}
.ss-back_td {
  background: url("../assets/images/back_td.png") no-repeat center center;
  background-size: 50px;
}
.ss-style_t_2_slider >>> .ant-slider {
  margin: 0;
}
.ss-style_t_2_slider >>> .ant-slider-handle {
  width: 10px;
  height: 10px;
  margin-top: -3px;
}
.ss-style_t_2_slider_box {
  width: 220px;
}
</style>
